import * as actionTypes from './actionTypes';
import { axiosPublic } from '../../axios-wizard';
import { fetchUsers } from './users';

export const recreatePassword = (data, token) => {
    const url = '/api/set_new_password/' + token

    const pw_data = {
      password: data['password'],
      token: token
    }
    return dispatch => {
        dispatch( recreatePasswordStart() );
        return axiosPublic.post( url, pw_data )
            // .then( response => {
            //    dispatch(registerVerificationSuccess(response.data));
            // } )
            // .catch( error => {
            //     dispatch(registerVerificationFailed());
            // } );
    };
};

export const recreatePasswordStart = () => {
    return {
        type: actionTypes.RECREATE_PASSWORD_START
    };
};

export const recreatePasswordSuccess = ( normalizedUsers ) => {
    return {
        type: actionTypes.RECREATE_PASSWORD_SUCCESS,
        values: normalizedUsers
    };
};

export const recreatePasswordFailed = () => {
    return {
        type: actionTypes.RECREATE_PASSWORD_FAILED
    };
};






export const registerVerification = (token) => {
    const url = '/api/verify_registration/' + token

    return dispatch => {
        dispatch( registerVerificationStart() );
        return axiosPublic.post( url )
            .then( response => {
               dispatch(registerVerificationSuccess(response.data));
               return true;
            } )
            .catch( error => {
                dispatch(registerVerificationFailed());
                return false;
            } );
    };
};

export const registerVerificationStart = () => {
    return {
        type: actionTypes.REGISTER_VERIFICATION_START
    };
};

export const registerVerificationSuccess = ( normalizedUsers ) => {
    return {
        type: actionTypes.REGISTER_VERIFICATION_SUCCESS,
    };
};

export const registerVerificationFailed = () => {
    return {
        type: actionTypes.REGISTER_VERIFICATION_FAILED
    };
};


export const login = (data) => {

    const url = '/api/login/'
    const auth_data = {
                        email: data['email'],
                        password: data['password']
                      }

    return dispatch => {
        dispatch({
          type: actionTypes.AUTH_START
        });
        return axiosPublic.post( url, auth_data )
            .then( response => {
               const expirationDate = new Date(new Date().getTime() + response.data.expiration * 1000);
               localStorage.setItem("token", response.data.token);
               localStorage.setItem("expirationDate", expirationDate);
               localStorage.setItem("userId", response.data.user['id']);
               dispatch( authSuccess(response.data.token, response.data.user.id) );
               dispatch( checkAuthTimeout(response.data.expiration) );
               dispatch( fetchUsers([localStorage.getItem("userId")]) );
            } )
            .catch( error => {
                dispatch({
                  type: actionTypes.AUTH_FAILED
                });
              return error.response.data;
            } );
    };

};

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(authLogout());
        }, expirationTime * 1000);
    };
};

export const authLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userId');
    return dispatch => {
      dispatch({
        type: actionTypes.AUTH_LOGOUT
      });
    };
};

export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        if (!token) {
            dispatch(authLogout());
        } else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            if (expirationDate <= new Date()) {
                dispatch(authLogout());
            } else {
                const userId = localStorage.getItem('userId');
                dispatch(authSuccess(token, userId));
                dispatch( fetchUsers([localStorage.getItem("userId")]) );
                dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000 ));
            }
        }
    };
};


export const authSuccess = (token, userId) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        token: token,
        userId: userId
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/auth.js